import * as engine from './planning-engine';
import { SectionNumber } from './planning-engine/planningTypes';

export const normalizeStr = engine.normalizeStr;
export const VERSION = "v18.12.71-HYDRATION-PERSISTENCE-HARDLOCK";
export const isVal = engine.isMeaningfulValue;
export const PLANNING_SECTION_CONTRACT = engine.PLANNING_SECTION_CONTRACT;
export const resolveCanonicalSectionNumber = engine.resolveCanonicalSectionNumber;
export const normalizeSectionContent = (sectionOrSn: any, rawContent: any): any => {
    const sn = typeof sectionOrSn === 'number'
        ? sectionOrSn
        : engine.resolveCanonicalSectionNumber(sectionOrSn);

    if (sn === null || sn === undefined) {
        return rawContent && typeof rawContent === 'object' ? { ...rawContent } : (rawContent || {});
    }

    return engine.normalizeSectionContent(sn, rawContent);
};

/**
 * v18.12.65: Wrapper para compatibilidad con la firma antigua de App_V3.tsx
 */
export const computeSectionMetrics = (sectionNumber: number, rawContent: any, manualGoal: number = 0): { goal: number; progress: number } => {
    // Convertimos al formato de objeto que espera el nuevo engine
    const sectionObj = {
        id: `S${sectionNumber}`,
        section_number: sectionNumber,
        content: rawContent,
        goal: manualGoal
    };
    
    const metrics = engine.computeSectionMetrics(sectionObj);
    return {
        goal: metrics.goal,
        progress: metrics.progress
    };
};

export const detectStructuralType = (section: any): string => {
    const sn = engine.resolveCanonicalSectionNumber(section);
    if (sn && engine.PLANNING_SECTION_CONTRACT[sn as SectionNumber]) {
        return engine.PLANNING_SECTION_CONTRACT[sn as SectionNumber].type;
    }
    return 'UNKNOWN';
};

export const getNormalizedData = (type: string, content: any, sn: number): any[] => {
    if (!content) return [];
    if (sn !== null && sn >= 1 && sn <= 9) {
        const normalized = engine.normalizeSectionContent(sn, content);
        const contract = engine.PLANNING_SECTION_CONTRACT[sn as SectionNumber];
        const canonicalKey = contract ? contract.canonicalKey : `sec${sn}_data`;
        return Array.isArray(normalized[canonicalKey]) ? normalized[canonicalKey] : [];
    }
    return [];
};

export const pick = (row: any, aliases: string[]): any => {
    if (!row || typeof row !== 'object') return undefined;
    for (const key of aliases) {
        if (engine.isMeaningfulValue(row[key])) return row[key];
    }
    return undefined;
};

export const calculateDetailedProgress = (section: any, content: any): number => {
    const metrics = engine.computeSectionMetrics({
        ...section,
        content: content
    });
    return metrics.progress;
};

export const calculateDetailedGoal = (section: any, content: any, sectionGoal: number): number => {
    const metrics = engine.computeSectionMetrics({
        ...section,
        content: content,
        goal: sectionGoal
    });
    return metrics.goal;
};

export const safeUpdateContent = (section: any, content: any, type: string, val: any): any => {
    const newContent = { ...(content || {}) };
    const sn = engine.resolveCanonicalSectionNumber(section);

    if (sn === null) {
        console.warn("[safeUpdateContent] No se pudo resolver el número de sección.");
        return newContent;
    }

    const contract = engine.PLANNING_SECTION_CONTRACT[sn as SectionNumber];
    if (contract && type === contract.type) {
        newContent[contract.canonicalKey] = val;
    } else {
        newContent[type] = val;
    }

    return newContent;
};

export const getSectionSchemaFromContent = (section: any, defaultCols: any[]) => {
    const content = typeof section?.content === 'string' ? JSON.parse(section.content) : section?.content;
    const sn = engine.resolveCanonicalSectionNumber(section);
    
    if (sn === null) return defaultCols;
    if (content?.[`_config_columns_sec${sn}`]) return content[`_config_columns_sec${sn}`];
    
    return defaultCols;
};
